// Reads an element's rendered height and width in whole pixels.
export const getElementSize = (el: Element) => {
  const { height, width } = window.getComputedStyle(el);
  return { height: parseInt(height), width: parseInt(width) };
};
